export const DEFAULT = "";
export const CREATING_SHIFT = "CREATING_SHIFT";
export const EDITING_SHIFT = "EDITING_SHIFT";
export const EXTENDING_SHIFT = "EXTENDING_SHIFT";
export const DELETING_SHIFT = "DELETING_SHIFT";

export const FILTERING_SHIFTS = "FILTERING_SHIFTS";
